export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('form_label_userPaymentRequestNo') || '日常请款单编号',
    field: 'userPaymentRequestNo',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
  },
  {
    title: that.$l('table_label_salesPersonCode') || '业务人员',
    field: 'salesPersonName',
    minWidth: 144,
    align: 'center',
  },
  {
    title: that.$l('form_label_requestDate') || '申请日期',
    field: 'requestDate',
    minWidth: 107,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('form_label_userPaymentRequestStatus') || '状态',
    field: 'userPaymentRequestStatus',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    slots: {
      default: 'status'
    }
  },
  {
    title: that.$l('form_label_payeeType') || '收款方',
    field: 'v_payeeType',
    width: 100,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('form_label_showPayee') || '收款单位',
    field: 'v_showPayee',
    minWidth: 190,
    headerAlign: 'center',
    align: 'left',
  },
  {
    title: that.$l('form_label_currencyAmount') || '费用合计',
    field: 'v_currencyAmount',
    minWidth: 140,
    headerAlign: 'center',
    align: 'center',
    slots: {
      default: 'showAmount'
    }
  },
  {
    title: that.$l('form_label_expensePayer') || '费用付款方',
    field: 'expensePayerName',
    minWidth: 240,
    headerAlign: 'center',
    align: 'left',
  },
  {
    title: that.$l('form_label_paymentMethod') || '付款方式',
    field: 'v_paymentMethod',
    width: 120,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    slots: {default: 'createByName'}
  },
  {
    title: that.$l('table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    slots: {default: 'modifyByName'}
  }
]
